import { render, staticRenderFns } from "./OrderPayments.vue?vue&type=template&id=0afb7d2e&scoped=true&"
import script from "./OrderPayments.vue?vue&type=script&lang=js&"
export * from "./OrderPayments.vue?vue&type=script&lang=js&"
import style0 from "./OrderPayments.vue?vue&type=style&index=0&id=0afb7d2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afb7d2e",
  null
  
)

export default component.exports